import { render, staticRenderFns } from "./PedidosRuta.vue?vue&type=template&id=1c6e0450"
import script from "./PedidosRuta.vue?vue&type=script&lang=js"
export * from "./PedidosRuta.vue?vue&type=script&lang=js"
import style0 from "./PedidosRuta.vue?vue&type=style&index=0&id=1c6e0450&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports